// extracted by mini-css-extract-plugin
export default {"container":"CircleIcon_container__CgYFr","icon":"CircleIcon_icon__q7lK8","footerIcon":"CircleIcon_footerIcon__SJ2Hw"};